import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";

function ArticleReadMore({ navigatePath, className = "absolute bottom-5 left-5 mt-2 " }: { navigatePath: string | null; className?: string }) {
  const { t } = useTranslation();
  const { normalInter } = useFontStyle();
  return (
    <div className={cn(className)}>
      <div
        className={cn(
          normalInter,
          `flex gap-x-2 items-center justify-center text-14 2xl:text-14 text-textHeadingColor ${navigatePath ? "cursor-pointer" : "cursor-default"}`,
        )}
      >
        {t("common.read_more", { defaultValue: "Read More" })} <ArrowRight size={16} />
      </div>
    </div>
  );
}

export default ArticleReadMore;
